import { Injectable } from '@angular/core';
import { Observable, from, interval, of, take } from 'rxjs';
import { EncryptionService } from './encryption.service';
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  eventName: string = "";
  parameters: any = {};
  public startDate$!: Observable<any>;
  public endDate$!: Observable<any>;
  public timediff$!: Observable<any>;
  private appInitialized = false;
  private analytics: any;

  constructor(private encryptionService: EncryptionService) { }



initFirebase(): void {
  if (this.appInitialized) return;
  const encryptedConfigString = localStorage.getItem('fconfig');
  if (encryptedConfigString) {
    // Decrypt the whole JSON string
    const decryptedConfigString = this.encryptionService.decryptString(encryptedConfigString);
    const decryptedConfig = JSON.parse(decryptedConfigString);
    // Build Firebase config
    const firebaseConfig = {
      apiKey: decryptedConfig.firebase_apiKey,
      authDomain: decryptedConfig.firebase_authDomain,
      projectId: decryptedConfig.firebase_projectId,
      storageBucket: decryptedConfig.firebase_storageBucket,
      messagingSenderId: decryptedConfig.firebase_messagingSenderId,
      appId: decryptedConfig.firebase_appId,
      measurementId: decryptedConfig.firebase_measurementId,
    };

    const app = initializeApp(firebaseConfig);
    this.analytics = getAnalytics(app);
    this.appInitialized = true;
    console.log('Firebase initialized after login with decrypted config');
  } else {
    console.log('Encrypted Firebase config not found in local storage');
  }
}


  addFirebaseNewEvent(eventName: string, description: any) {
    if (!this.analytics) return;

    const username = this.encryptionService.getFromLocalStorage('username');
    const position_type = this.encryptionService.getFromLocalStorage('position_type');
    const user_type = this.encryptionService.getFromLocalStorage('user_type')?.toUpperCase();

    const updatedDescription = {
      ...description,
      username,
      position_type,
      user_type
    };

    logEvent(this.analytics, eventName, updatedDescription);
  }

  addNewFirebaseEvent(...args: any): void {
    var eventName = args[0] || "";
    var screenName = args[1] || "";
    var eventData = args[2] || [];

    this.eventName = eventName;
    this.parameters = {
      'screen': screenName,
      'user_name': this.encryptionService.getFromLocalStorage('username') || "",
      'key_cloak_id': localStorage.getItem('kc_id') || "",
    };

    if (eventData && Object.keys(eventData).length) {
      if (eventData['vehicle_info'] && Object.keys(eventData['vehicle_info']).length) {
        this.parameters = {
          ...this.parameters,
          ...eventData['vehicle_info'],
          registration_number: eventData['vehicle_info']['registration_number'],
          vin: eventData['vehicle_info']['vin'],
          lob: eventData['vehicle_info']['lob'],
          ppl: eventData['vehicle_info']['ppl'],
          pl: eventData['vehicle_info']['pl']
        };
      }
    }

    if (args[3] && Object.keys(args[3]).length) {
      var additionalDataObj = { "additional_data": args[3] };
      this.parameters = { ...this.parameters, ...additionalDataObj };
    }

    if (this.analytics) {
      logEvent(this.analytics, this.eventName, this.parameters);
    }
  }

  addNewEvent(eventName: string, screenName: string, eventData: any, additionalData: any = []) {
    if (!(additionalData && Object.keys(additionalData).length)) {
      this.addNewFirebaseEvent(eventName, screenName, eventData, additionalData);
    } else {
      this.addNewFirebaseEvent(eventName, screenName, eventData);
    }
  }

  setStartDate() {
    this.startDate$ = of(new Date());
  }

  setEndDate() {
    this.endDate$ = of(new Date());
  }

  resetEndDate() {
    this.endDate$ = of();
  }

  getTimeDiff(startTime: any, endTime: any) {
    let stdt: any;
    let endt: any;
    let timeDiff: any;

    let timedf = interval(1).pipe(take(1)).toPromise().then(() => {
      from(this.startDate$).toPromise().then(b => {
        stdt = b;
      });
    }).then(() => {
      from(this.endDate$).toPromise().then(d => {
        endt = d;
      });
    }).then(() => {
      timeDiff = Math.abs(endt - stdt);
      this.timediff$ = (timeDiff);
      if (JSON.stringify(endt) == JSON.stringify({})) {
        return 0;
      }
      return timeDiff;
    });
    return timedf;
  }
}
